var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-lg py-1 flex-grow-1",attrs:{"data-aos":_vm.animation,"data-aos-easing":"ease","data-aos-duration":"500","data-aos-once":"true"}},[(_vm.topico)?_c('Topico',{attrs:{"titulo":_vm.topico}}):_vm._e(),(_vm.subTopico)?_c('Subtopico',{attrs:{"titulo":_vm.subTopico}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }